import { useEffect } from 'react'
import { isEmpty } from 'lodash'
import { useUserInfo } from '../use-userInfo'
import useIsPwa from '../use-is-pwa'
import { usePostHog } from 'posthog-js/react'
import type { PostHogUserProperties } from './usePostHogIdentify.types'
import { userSet, userIdentify } from '../../analytics/analytics'

const usePostHogIdentify = () => {
  const { user } = useUserInfo()
  const { isPwa } = useIsPwa()
  const posthog = usePostHog()

  const isTeacher = !isEmpty(user?.teacher)

  const userProperties: PostHogUserProperties = {
    user_id: Number(user?.id),
    name: user?.name,
    email: user?.email,
    token_arvore: user?.accessToken,
    entity_id: user?.reader?.entity?.id,
    entity_name: user?.reader?.entity?.name,
    root_name: user?.reader?.root?.name,
    root_id: user?.reader?.root?.id,
    root_id_string: user?.reader?.root?.id?.toString(),
    contract_type: user?.reader?.entity?.contractInfo?.type,
    acervo_type: user?.reader?.root?.root_acervo,
    user_segment: user?.reader?.root?.segment,
    user_degree: user?.reader?.entity?.degree,
    user_type: isTeacher ? 'educador' : 'aluno',
    job_positions: user?.jobPositions,
    job_areas: user?.jobAreas,
    modules: user?.reader?.contentFilters,
    display_mode: isPwa
      ? 'pwa'
      : window.ReactNativeWebView
      ? 'webview'
      : 'browser'
  }

  const stringifiedProperties = JSON.stringify(userProperties)

  useEffect(() => {
    if (user?.id && posthog) {
      userIdentify(user.id)
      userSet(userProperties)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stringifiedProperties, posthog])
}

export default usePostHogIdentify
